import styled from 'styled-components';

const ErrorPage = styled.div`
  position: relative;
  padding: 60px 0;

  @media (max-width: 576px) {
    padding: 30px 0;
  }
`;

const ErrorPageInner = styled.div`
  text-align: center;

  h1 {
    margin-bottom: 30px;

    @media (max-width: 576px) {
      margin-bottom: 18px;
    }
  }

  p {
    font-weight: 600;
    max-width: 460px;
    margin: 0 auto 30px;

    @media (max-width: 576px) {
      margin: 0 auto 18px;
    }
  }
`;

const ErrorImage = styled.div`
  margin-top: 60px;

  @media (max-width: 576px) {
    margin-top: 20px;
  }

  img, .isvg {
    width: 300px;
    height: 300px;
    max-width: 100%;
    display: block;
    margin: 0 auto;

    @media (max-width: 576px) {
      width: 180px;
      height: 180px;
    }
  }
`;

export {
  ErrorPage,
  ErrorPageInner,
  ErrorImage
};
